module.exports = __webpack_public_path__ + "img/@logo_11st@3x.f63337e8.png";